import { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField,
  Checkbox,
  Typography,
} from '@material-ui/core';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { useMutation } from '@apollo/client';
import { UserMutations } from '../../models/user';

const AccountProfileDetails = ({ user }) => {
  const [updateUserProfile] = useMutation(UserMutations.updateUserProfile);
  // const [values, setValues] = useState({});
  //
  // const handleChange = (event) => {
  //   setValues({
  //     ...values,
  //     [event.target.name]: event.target.value,
  //   });
  // };

  const onSubmit = async (values) => {
    console.log({ values });
    await updateUserProfile({
      variables: {
        id: values._id,
        ...values,
      },
    });
  };

  const onRemoveRequestSubmit = async () => {
    await updateUserProfile({
      variables: {
        id: user._id,
        removeChatRequest: true,
      },
    });
  };

  console.log({ user });

  return (
    <Formik initialValues={user} enableReinitialize onSubmit={onSubmit}>
      {({ handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
        <form onSubmit={handleSubmit}>
          <Card>
            <CardHeader subheader="The information can be edited" title="Profile" />
            <Divider />
            <CardContent>
              <Grid container spacing={3}>
                <Grid item md={6} xs={12}>
                  <TextField
                    fullWidth
                    label="Full Name"
                    name="fullName"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    required
                    value={values?.fullName || ''}
                    variant="outlined"
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <TextField
                    fullWidth
                    label="Email Address"
                    name="email"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    required
                    value={values?.email || ''}
                    variant="outlined"
                  />
                </Grid>

                <Grid item md={12} xs={12}>
                  <Box
                    sx={{
                      pt: 2,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'flex-end',
                    }}
                  >
                    <Typography align="center" color="textPrimary">
                      Is in Diploma Holders/Students IACH Chat Room chat group?
                    </Typography>
                    <Checkbox
                      color="primary"
                      label="ISCH"
                      name="isISCH"
                      onChange={handleChange}
                      checked={Boolean(values?.isISCH)}
                    />
                  </Box>
                </Grid>
              </Grid>
            </CardContent>
            <Divider />
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                p: 2,
              }}
            >
              {!values?.isISCH && user?.hasRequest && (
                <Button
                  onClick={() => onRemoveRequestSubmit()}
                  color="error"
                  variant="outlined"
                  disabled={isSubmitting}
                >
                  Remove Request
                </Button>
              )}
              &nbsp;
              <Button type="submit" color="primary" variant="contained" disabled={isSubmitting}>
                Save details
              </Button>
            </Box>
          </Card>
        </form>
      )}
    </Formik>
  );
};

export default AccountProfileDetails;
